function lightSurfaces({ ink, panelEnd, primaryRgb, shadow }) {
  return {
    "--color-text-soft": `rgba(${ink}, 0.5)`,
    "--color-text-faint": `rgba(${ink}, 0.38)`,
    "--color-text-dim": `rgba(${ink}, 0.28)`,
    "--color-watermark": `rgba(${ink}, 0.08)`,
    "--color-card": "rgba(255, 255, 255, 0.9)",
    "--color-card-strong": "#ffffff",
    "--color-panel": `linear-gradient(165deg, #ffffff 0%, ${panelEnd} 100%)`,
    "--color-card-scrim":
      "linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.78) 22%, rgba(255, 255, 255, 0.97) 100%)",
    "--color-fill-soft": `rgba(${ink}, 0.045)`,
    "--color-fill-mid": `rgba(${ink}, 0.08)`,
    "--color-on-primary": "#ffffff",
    "--color-focus": `rgba(${primaryRgb}, 0.65)`,
    "--color-shadow": shadow,
    "--color-primary-soft": `rgba(${primaryRgb}, 0.14)`,
  };
}

export const THEMES = {
  steel: {
    id: "steel",
    name: "White & Steel",
    tagline: "White-to-steel gradient bands",
    scheme: "light",
    swatch: ["#344555", "#ffffff", "#8a96a3"],
    css: {
      "--color-bg": "#ffffff",
      "--color-bg-elevated": "#ffffff",
      "--color-surface": "#ffffff",
      "--color-surface-glass": "rgba(255, 255, 255, 0.9)",
      "--bg-gradient":
        "radial-gradient(1100px 720px at 8% -8%, #ffffff 0%, transparent 58%), radial-gradient(900px 640px at 92% 12%, #b8c2cc 0%, transparent 52%), linear-gradient(180deg, #ffffff 0%, #e0e7ee 55%, #c5ced6 100%)",
      "--color-text": "#1c242c",
      "--color-text-muted": "rgba(28, 36, 44, 0.58)",
      "--color-primary": "#344555",
      "--color-accent": "#4c5f73",
      "--color-secondary": "#3f5163",
      "--color-border": "rgba(28, 36, 44, 0.12)",
      "--nav-scrim-strong": "rgba(255, 255, 255, 0.96)",
      "--nav-scrim-mid": "rgba(244, 246, 248, 0.72)",
      "--title-stroke": "rgba(28, 36, 44, 0.22)",
      "--logo-blend": "multiply",
      "--canvas-opacity": "0.14",
      "--canvas-blend": "multiply",
      "--three-bg": "#e0e7ee",
      "--btn-sheen": "#8a96a3",
      "--selection-bg": "rgba(52, 69, 85, 0.22)",
      ...lightSurfaces({
        ink: "28, 36, 44",
        panelEnd: "#d5dde4",
        primaryRgb: "52, 69, 85",
        shadow: "rgba(28, 36, 44, 0.16)",
      }),
    },
    three: {
      background: 0xe0e7ee,
      primary: 0x344555,
      accent: 0x4c5f73,
      particle: 0x6d7d8c,
    },
  },
};

export const DEFAULT_THEME_ID = "steel";
export const THEME_EVENT = "taldel:theme";

export const theme = {
  colors: {
    bg: THEMES.steel.css["--color-bg"],
    bgElevated: THEMES.steel.css["--color-bg-elevated"],
    text: THEMES.steel.css["--color-text"],
    textMuted: THEMES.steel.css["--color-text-muted"],
    primary: THEMES.steel.css["--color-primary"],
    accent: THEMES.steel.css["--color-accent"],
    border: THEMES.steel.css["--color-border"],
  },
  three: THEMES.steel.three,
};

export function getTheme(id = DEFAULT_THEME_ID) {
  return THEMES[id] || THEMES[DEFAULT_THEME_ID];
}

export function applyTheme(id = DEFAULT_THEME_ID) {
  const next = getTheme(id);
  const root = document.documentElement;
  root.dataset.theme = next.id;
  root.dataset.scheme = next.scheme;

  Object.entries(next.css).forEach(([key, value]) => {
    root.style.setProperty(key, value);
  });

  theme.three = next.three;
  window.dispatchEvent(new CustomEvent(THEME_EVENT, { detail: next }));
  return next;
}
